import React from 'react';
import SellerMenu from './SellerMenu';

function SellerLayout({ children }) {
  return (
    <>
      <SellerMenu />
      <div className="seller-page-container">
        <div className="seller-content-wrapper">
          {children}
        </div>
      </div>
    </>
  );
}

export default SellerLayout; 